import { useState } from 'react';

const BuyerMarketPlaceCard = (props: {
    industry: string;
    subIndustry: string;
    otherIndustry?: string;
    image: string;
    weeklyQuantity: number;
    extra?: string;
    status: string;
    targetPrice: string;
    onClick?: any;
    leadsGenerated?: number;
    buyerPrice?: any;
    user?: any;
    offerNumber?: string;
    channels: any;
    isGuest?: boolean;
    onGuestClick?: () => void;
}) => {
    const {
        industry,
        subIndustry,
        buyerPrice,
        otherIndustry,
        weeklyQuantity,
        offerNumber,
        image,
        extra,
        onClick,
        isGuest = false,
        onGuestClick,
        channels,
    } = props;

    const [imgError, setImgError] = useState(false);
    const showPlaceholder = !image || imgError;

    return (
        <div
            className={`flex flex-col w-full bg-white border border-leadrs-stroke rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-200 ${extra}`}
            onClick={(e) => {
                if (isGuest && onGuestClick) {
                    onGuestClick();
                } else if (onClick) {
                    onClick();
                }
            }}
        >
            {/* Photo */}
            {showPlaceholder ? (
                <div className="flex h-[155px] w-full items-center justify-center bg-leadrs-bg px-4">
                    <div className="text-center">
                        <p className="font-crimson text-xl font-semibold text-leadrs-text">{industry}</p>
                        <p className="font-geist text-xs text-leadrs-text-soft">{otherIndustry || subIndustry}</p>
                    </div>
                </div>
            ) : (
                <img
                    src={image}
                    className="w-full h-[155px] object-cover"
                    alt=""
                    onError={() => setImgError(true)}
                />
            )}

            {/* Content */}
            <div className="p-4 flex flex-col gap-2.5">
                <p className="text-xs font-geist text-leadrs-text-soft">
                    {otherIndustry || subIndustry}
                </p>
                <div className="flex items-center gap-2">
                    <p className="font-crimson text-[22px] font-semibold text-leadrs-text leading-tight">{industry}</p>
                    {offerNumber && (
                        <p className="flex-shrink-0 font-geist text-xs text-leadrs-text-soft">#{offerNumber}</p>
                    )}
                </div>
                <p className="text-sm font-geist text-leadrs-text-soft">
                    Prix par lead : {isGuest ? '···' : `${buyerPrice}€`}
                </p>

                {/* Leads disponible badge */}
                <span className="w-fit rounded-full bg-leadrs-green-soft px-3 py-1 text-xs font-medium font-geist text-leadrs-green-focus">
                    {weeklyQuantity} leads disponible
                </span>

                {/* Channels */}
                <div>
                    <p className="text-xs font-geist text-leadrs-text-soft mb-1.5">
                        Canaux :
                    </p>
                    <div className="flex flex-wrap gap-1">
                        {channels?.map((channel: string) => (
                            <span
                                key={channel}
                                className="border border-leadrs-stroke rounded px-2 py-0.5 text-xs font-geist text-leadrs-text"
                            >
                                {channel}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuyerMarketPlaceCard;
